import $ from "jquery";
import Foundation from "./3rd/_zf.js";

import "./utils/global.js";
import "./utils/back-to-top.js";
import "./utils/script-loader.js";
import { initMenu } from "./utils/menu.js";

import { initSocialShare } from "./components/social-share.js";

// Styles
import "../styles/3rd/_index.scss";

// DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  initMenu("nav.nav", ".main-nav");
  initSocialShare("[data-social-share]", {
    intents: ["facebook", "x", "print", "send-email", "copy-link", "web-share"],
  });

  //
  // toggle menu footer
  //
  document.querySelectorAll("#footer-columns .footer-title").forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      this.classList.toggle("active");
    });
  });

  //
  // product attributes
  //
  const MIN_WIDTH = 250;
  const widgets = document.querySelectorAll(
    ".product-attributes .widget_layered_nav"
  );

  function adjustDropdown(widget) {
    const dropdown = widget.querySelector("ul");
    if (!dropdown) return;

    const toggleElem = widget.querySelector("span") || widget;
    const rect = toggleElem.getBoundingClientRect();
    const spaceRight = window.innerWidth - rect.right;

    if (spaceRight < MIN_WIDTH) {
      dropdown.classList.add("align-right");
    } else {
      dropdown.classList.remove("align-right");
    }
  }

  function closeAll() {
    widgets.forEach((el) => el.classList.remove("active"));
  }

  widgets.forEach((widget) => {
    widget.addEventListener("click", (e) => {
      if (e.target.closest("ul")) return;

      e.preventDefault();
      const isActive = widget.classList.contains("active");

      closeAll();

      if (!isActive) {
        widget.classList.add("active");
        adjustDropdown(widget);
      }
    });
  });

  window.addEventListener("resize", () => {
    const openWidget = document.querySelector(
      ".product-attributes .widget_layered_nav.active"
    );
    if (openWidget) adjustDropdown(openWidget);
  });
});

const observer = new MutationObserver(function (mutations, obs) {
  const emptyCartTitle = document.querySelector(
    ".wc-block-cart__empty-cart__title"
  );
  if (emptyCartTitle) {
    emptyCartTitle.textContent = "Giỏ hàng của bạn đang trống!";
    obs.disconnect(); // Dừng theo dõi sau khi đã thay xong
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener("DOMContentLoaded", function () {
  const shareTitle = document.querySelector(".share-title");
  if (shareTitle) {
    shareTitle.textContent = "Chia sẻ";
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelector(".hotline").addEventListener("click", openModal);

//   function openModal() {
//     document.getElementById("myModal").style.display = "flex";
//   }

//   function closeModal() {
//     document.getElementById("myModal").style.display = "none";
//   }

//   document.getElementById("myModal").addEventListener("click", function (event) {
//     if (event.target.classList.contains("modal-overlay")) {
//       closeModal();
//     }
//   });

//   // Close button
//   document.querySelector(".modal-close").addEventListener("click", closeModal);
// });

window.addEventListener('scroll', function() {
    const header = document.querySelector('.masthead_bottom');
    if (window.scrollY > 120) {
        header.classList.add('fixed');
    } else {
        header.classList.remove('fixed');
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll('.all_content_home_services,.section-home-forms');

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target); // Nếu bạn chỉ muốn hiệu ứng xảy ra 1 lần
            }
        });
    }, {
        threshold: 0.1 // khoảng 10% hiện trong khung nhìn là kích hoạt
    });

    elements.forEach(el => observer.observe(el));
});